class StorageAPI{
  constructor(name){
    this.localStorageKey = name;
    this.isAvailable = this.storageAvailable();
  }

  storageAvailable() {
    try {
      let storage = window.localStorage,
        x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    }
    catch(e) {
      return false;
    }
  }

  getData(){
    if (this.isAvailable){
      const data = localStorage.getItem(this.localStorageKey);
      return (data && JSON.parse(data)) || null;
    }
    return null;
  }

  setData(data) {
    if (this.isAvailable) return localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  removeData() {
    if (this.isAvailable) localStorage.removeItem(this.localStorageKey);
  }

  clearData(){
    if (this.isAvailable) localStorage.clear();
  }

  addData(data) {
    if (this.isAvailable) {
      let existData = this.getData();
      let newData;
      if (existData) newData = {...existData, ...data}
      else newData = data
      return localStorage.setItem(this.localStorageKey, JSON.stringify(newData));
    }
  }
};

export default StorageAPI;
